export default __webpack_public_path__ + "static/media/good-stand1.e34bd6f6.png";